import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Interceptor HTTP para enviar el access_token y la sesión completa en cada petición.
 * Lee la sesión desde localStorage y envía:
 * - access_token en el header Authorization
 * - session completa en el header X-Session
 * Compatible con iOS/Android donde document.cookie está bloqueado.
 */
export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  // Obtener la sesión del localStorage
  const sessionEncoded = localStorage.getItem('session');
  
  if (sessionEncoded) {
    try {
      // Decodificar la sesión (está en base64)
      const sessionData = JSON.parse(atob(sessionEncoded));
      
      if (sessionData.accessToken) {
        // Clonar la petición y agregar el token y la sesión en headers
        const clonedReq = req.clone({
          setHeaders: {
            'Authorization': `Bearer ${sessionData.accessToken}`,
            'X-Session': sessionEncoded // Enviar la sesión completa codificada en base64
          },
          withCredentials: true // Para compatibilidad con cookies en web
        });
        
        return next(clonedReq);
      }
    } catch (error) {

    }
  }
  
  // Si no hay sesión o hubo error, continuar con la petición original
  return next(req);
};
